import {
  Button,
  Card,
  Col,
  EditButton,
  Form,
  FormProps,
  Icons,
  Input,
  List,
  Pagination,
  Row,
  Space,
  Table,
  useTable,
} from '@pankod/refine-antd'
import { CrudFilters, CrudSort, HttpError, usePermissions } from '@pankod/refine-core'
import { IClient, IClientFilterVariables } from 'interfaces'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { convertOrderKey, is, maxLength } from 'utils'
import { ErrorComponent } from 'components/404/ErrorComponent'

export const ClientList: React.FC = () => {
  const [sortCondition, setSortCondition] = useState({} as CrudSort)
  const [currentPage, setCurrentPage] = useState(1)
  const { tableProps, searchFormProps, filters, tableQueryResult } = useTable<
    IClient,
    HttpError,
    IClientFilterVariables
  >({
    permanentSorter: [sortCondition],
    permanentFilter: [{ field: 'id', operator: 'ne', value: 'Q2xpZW50OjE=' }], // 事務局除外
    metaData: {
      fields: ['id', 'clientName', 'clientCd', 'vcid', 'subAccountId'],
      current: currentPage,
      pageSize: 10,
    },
    onSearch: (params) => {
      const filters: CrudFilters = []
      const { clientName, clientCd } = params

      filters.push({
        field: 'clientName',
        operator: 'contains',
        value: clientName ? clientName : null,
      })

      filters.push({
        field: 'clientCd',
        operator: 'contains',
        value: clientCd ? clientCd : null,
      })

      return filters
    },
  })

  const { data: permissions } = usePermissions()
  if (!permissions?.includes('CLIENT')) {
    return <ErrorComponent />
  }

  const onChangePage = (page: number) => {
    setCurrentPage(page)
    tableQueryResult.refetch()
  }

  return (
    <>
      <Helmet>
        <title>{`依頼主 | ${process.env.REACT_APP_SERVICE_NAME}`}</title>
        <meta name="description" content={`依頼主 | ${process.env.REACT_APP_SERVICE_NAME}`} />
      </Helmet>
      <Row gutter={[16, 16]}>
        <Col xl={6} lg={24} xs={24}>
          <Card bordered={false} title={'フィルター'}>
            <Filter formProps={searchFormProps} filters={filters || []} setCurrentPage={setCurrentPage} />
          </Card>
        </Col>
        <Col xl={18} xs={24}>
          <List>
            <Table
              {...tableProps}
              rowKey="id"
              pagination={false}
              onChange={(_pagination, _filters, sorter: any) => {
                let field = ''
                if (is('String', sorter.field)) field = sorter.field
                else field = sorter.field.slice(-1)[0]
                setSortCondition({ field: field, order: convertOrderKey(sorter.order) } as CrudSort)
                tableQueryResult.refetch()
              }}
            >
              <Table.Column dataIndex="clientCd" title="依頼主コード" sorter ellipsis />
              <Table.Column dataIndex="clientName" title="依頼主" sorter ellipsis />
              <Table.Column dataIndex="vcid" title="VCID" sorter ellipsis />
              <Table.Column dataIndex="subAccountId" title="SUB ACCOUNT ID" sorter ellipsis />
              <Table.Column<IClient>
                title="操作"
                dataIndex="actions"
                fixed="right"
                render={(_text, record): React.ReactNode => {
                  return (
                    <Space>
                      <EditButton size="small" recordItemId={record.id} icon={false} />
                    </Space>
                  )
                }}
              />
            </Table>
            <div style={{ textAlign: 'right', marginTop: '10px' }}>
              <Pagination
                current={currentPage}
                onChange={onChangePage}
                total={tableQueryResult?.data?.total}
                showSizeChanger={false}
              />
            </div>
          </List>
        </Col>
      </Row>
    </>
  )
}

const Filter: React.FC<{
  formProps: FormProps
  filters: CrudFilters
  setCurrentPage: (currentPage: number) => void
}> = (props) => {
  const { formProps, setCurrentPage } = props

  return (
    <Form layout="vertical" {...formProps}>
      <Row gutter={[10, 0]} align="bottom">
        <Col xl={24} md={8} sm={12} xs={24}>
          <Form.Item label={'依頼主コード'} name="clientCd" rules={[maxLength(6)]}>
            <Input placeholder={'部分一致検索'} prefix={<Icons.SearchOutlined />} maxLength={6} />
          </Form.Item>
        </Col>
        <Col xl={24} md={8} sm={12} xs={24}>
          <Form.Item label={'依頼主'} name="clientName" rules={[maxLength(100)]}>
            <Input placeholder={'部分一致検索'} prefix={<Icons.SearchOutlined />} maxLength={100} />
          </Form.Item>
        </Col>
        <Col xl={24} md={8} sm={12} xs={24}>
          <Form.Item>
            <Button htmlType="submit" type="primary" size="large" block onClick={() => setCurrentPage(1)}>
              {'絞り込み'}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
